"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import VirtualShopTagStatus from "../VirtualShopTagStatus.vue";
let ColumnProxy = class extends Mixins(AccountSessionMixins) {
  bindVd() {
    this.$emit("bindIP", this._column);
  }
  tobuyandbindVd() {
    return __async(this, null, function* () {
      let shop_id = this._column.id;
      this.$router.push({
        name: "payment",
        query: { style: "create" },
        params: {
          shop_id
        }
      });
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnProxy.prototype, "_column", 2);
ColumnProxy = __decorateClass([
  Component({
    components: {
      ItemShop,
      VirtualShopTagStatus
    }
  })
], ColumnProxy);
export {
  ColumnProxy as default
};
